import React from 'react'

import { ROLE_ADMIN, ROLE_CITY_MANAGER, ROLE_SPY } from '../../shared/constants'

const RoleLabel = ({ role, classes }) => {
  const roleMap = {
    [ROLE_ADMIN]: {
      label: 'Admin',
      color: '#D72B4F',
      backgroundColor: '#FFDAE1',
    },
    [ROLE_CITY_MANAGER]: {
      label: 'CM',
      color: '#0098D9',
      backgroundColor: '#E0F5FE',
    },
    [ROLE_SPY]: { label: 'Spy', color: '#9747FF', backgroundColor: '#F2E8FF' },
  }
  return (
    <div
      style={{
        fontSize: 16,
        borderRadius: 8,
        fontFamily: "'Proxima Nova', sans-serif",
        minWidth: 64,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: roleMap[role].color,
        backgroundColor: roleMap[role].backgroundColor,
      }}
    >
      {roleMap[role].label}
    </div>
  )
}
export default RoleLabel
